import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
import store from "./store";

Vue.config.productionTip = false;
//Brother when you see this code, I have resigned, you resign, hurriedly resign, hurriedly resign, this company is a pit, all kinds of pits, what benefits are not, the construction period desperately pressure, overtime without overtime pay no vacation
import './permission' 
import '@/icons' 


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import * as filters from './filters' 

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


import http from "./network/index";
Vue.prototype.$http = http;


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");